import {
  type EdgeData,
  type SnapshotId,
  rgbColorNumbers,
} from '@ipfabric/utils';
import type { CompareMode } from '../deviceViewTypes';

export const getEdgeCompareMode = (
  edgeData: EdgeData,
  snapshotToCompareId: SnapshotId | null,
): CompareMode | null => {
  if (snapshotToCompareId !== null) {
    if (edgeData.style?.line?.color === rgbColorNumbers.green) {
      return 'added';
    }
    if (edgeData.style?.line?.color === rgbColorNumbers.red) {
      return 'removed';
    }
    return 'untouched';
  }
  return null;
};
